import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getSSOConfig = api(async function getSSOConfig({ clientId } = {}) {
    return await query(
        gql`
            query getSSOConfig($clientId: String) {
                getSSOConfig(clientId: $clientId) {
                    _id
                    enabled
                    scimEnabled
                    providerName
                    ssoLoginUrl
                    idpCertificate
                    spEntityId
                    effectiveSpEntityId
                    acsUrl
                    emailDomains
                    emailAttribute
                    displayNameAttribute
                    wantAssertionsSigned
                    wantAuthnResponseSigned
                    enforceSSO
                    recentFailures
                    created
                    updated
                }
            }
        `,
        { clientId },
        { returns: "getSSOConfig", fetchPolicy: "network-only" }
    )
})

export const getSSOMetadataUrl = api(async function getSSOMetadataUrl({ clientId } = {}) {
    return await query(
        gql`
            query getSSOMetadataUrl($clientId: String) {
                getSSOMetadataUrl(clientId: $clientId)
            }
        `,
        { clientId },
        { returns: "getSSOMetadataUrl", fetchPolicy: "network-only" }
    )
})

export const getSSOServiceProviderDetails = api(async function getSSOServiceProviderDetails({ clientId } = {}) {
    return await query(
        gql`
            query getSSOServiceProviderDetails($clientId: String) {
                getSSOServiceProviderDetails(clientId: $clientId) {
                    entityId
                    acsUrl
                    metadataUrl
                }
            }
        `,
        { clientId },
        { returns: "getSSOServiceProviderDetails", fetchPolicy: "network-only" }
    )
})
